var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"analysis-box"},[_vm._m(0),_c('div',{staticClass:"analysis-box-content flex-box"},[_c('Chart',{ref:"chartBox",staticStyle:{"height":"300px","width":"100%"},attrs:{"option":_vm.barOptions}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"analysis-box-title flex-box flex-between flex-items"},[_c('span',[_vm._v("保单成分")])])
}]

export { render, staticRenderFns }